import { Link } from "react-router-dom";
import { Reveal } from "@components/ui";
import { jobs, getApplyMailtoLink } from "../../data/jobs";

const JobOpeningsSection = () => {
  return (
    <section id="job-openings" className="py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        <Reveal>
          <div className="flex flex-col items-center text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#f24d2b]/10 text-[#f24d2b] text-[14px] md:text-[16px] font-medium tracking-[-0.04em] mb-4">
              Opportunities
            </span>
            <h2 className="text-[28px] md:text-[44px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63]">
              Current Job Openings
            </h2>
            <p className="text-[20px] md:text-[24px] lg:text-[28px] text-[#62636c] tracking-[-0.04em] mt-3 max-w-[700px]">
              Find your perfect role and start your journey with GASIS
            </p>
          </div>
        </Reveal>

        <Reveal>
          <div className="rounded-[24px] border border-[rgba(98,99,108,0.2)] bg-white overflow-hidden">
            {jobs.map((job, index) => (
              <Link
                key={job.slug}
                to={`/careers/${job.slug}`}
                className={`group flex items-center justify-between py-5 px-4 md:px-6 hover:bg-[#f9f9fb] transition-colors duration-200 cursor-pointer no-underline ${
                  index < jobs.length - 1
                    ? "border-b border-[#b9bbc6]/40"
                    : ""
                }`}
              >
                <span className="text-[18px] md:text-[22px] lg:text-[24px] font-medium text-[#090d2c] tracking-[-0.04em]">
                  {job.title}
                </span>

                <div className="flex items-center gap-4 md:gap-6 shrink-0 ml-4">
                  <span className="hidden sm:inline text-[16px] md:text-[20px] text-[#62636c] tracking-[-0.04em]">
                    {job.location}
                  </span>
                  <span className="text-[16px] md:text-[20px] text-[#62636c] tracking-[-0.04em] flex items-center gap-1.5 group-hover:text-[#122d63] transition-colors duration-200">
                    View Job
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="group-hover:translate-x-1 transition-transform duration-200"
                    >
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </Reveal>

        <Reveal>
          <div className="flex justify-center">
            <a
              href={getApplyMailtoLink(jobs[0])}
              className="mt-10 mx-auto flex items-center gap-2.5 py-3 pl-6 pr-3 bg-[#090d2c] rounded-[40px] text-[16px] md:text-[18px] text-white font-medium font-albert-sans tracking-[-0.04em] hover:bg-[#1a1f3a] hover:shadow-[0_4px_16px_rgba(9,13,44,0.3)] transition-all duration-300 no-underline"
            >
              Apply Now
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default JobOpeningsSection;
